import React from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
// import {StyledFirebaseAuth} from "react-firebaseui";
// import { FIREBASE_CONFIG } from "../../config";
import firebase from "firebase/app";
// import { Redirect } from "react-router-dom";
import "./login.css";

const Login = ({ db }) => {
  // useEffect(() => {
  //   console.log("EFFECT -------------------- LOGIN  LOAD!")
  // }, [])

  // Configure FirebaseUI.
  const FIREBASE_UI_CONFIG = {
    // Popup signin flow rather than redirect flow.
    signInFlow: "redirect",
    // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
    // signInSuccessUrl: "/members/-1/any",
    callbacks: {
      signInSuccess: () => {
        console.log("SIGNIN SUCCESS: ", firebase.auth());
        const { currentUser } = firebase.auth();

        console.log("current user: ", currentUser);
        console.log("FIREBASE DB: ", db);

        // does the user exist ?
        db.collection("uid")
          .doc(currentUser.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              console.log("Document data:", doc.data());
              
              window.history.pushState(null, null, "#/members/-1/any");
              window.location.reload();
              // window.history.go();

            } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");

              db.collection("uid")
                .doc(currentUser.uid)
                .set({
                  Uid: currentUser.uid,
                  ID: "",
                  Name: currentUser.displayName,
                  Email: currentUser.email,
                  photoUrl: currentUser.photoURL,
                  Provider: currentUser.providerData[0].providerId,
                  accessType: {
                    member: false,
                    writer: false,
                    admin: false
                  }
                })
                .then(docRef => {
                  console.log("new TEST placeholder added with ID: ", docRef);

                  window.history.pushState(null, null, "#/members/-1/any");
                  // window.history.go();
                  window.location.reload();
                })
                .catch(function(error) {
                  console.error("Error adding document: ", error);
                });
            }
          });
      }
    },
    // We will display Google and Facebook as auth providers.
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      // firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID
    ]
  };

  return (
    <div className="login">
      <div className="login-wrapper">
        <img src="/icons/apple-icon-180x180.png" alt="logo" />
        <p>Log på</p>
        <StyledFirebaseAuth
          className="StyledFirebaseAuth"
          uiConfig={FIREBASE_UI_CONFIG}
          firebaseAuth={firebase.auth()}
        />
      </div>
    </div>
  );
};

export default Login;
